module.exports = __webpack_public_path__ + "img/160013.638d7776.png";